import createTableBody from './createTableBody';

// ----------------------------------------------------------------------------

function alreadyTableBody(element: HTMLElement, config?: Record<string, any>): HTMLTableSectionElement {
    let elTableBody = element.querySelector('tbody') as HTMLTableSectionElement | undefined;

    if (!elTableBody) {
        elTableBody = createTableBody(config);
        element.appendChild(elTableBody);
    }

    return elTableBody;
}

// ----------------------------------------------------------------------------

export default alreadyTableBody;
